<template>
  <div class="container mt-5">
    <h2 class="mb-4">Add Customer</h2>
    <form @submit.prevent="addCustomer">
      <div class="row">
        <!-- Display Name -->
        <div class="col-md-6 mb-3">
          <label for="displayName" class="form-label">Display Name</label>
          <input
            type="text"
            class="form-control"
            id="displayName"
            v-model="customer.displayName"
            required
          />
        </div>

        <div class="col-md-6 mb-3">
          <label for="fileInput" class="form-label"
            >Select Customer Image</label
          >
          <input
            type="file"
            class="form-control"
            id="fileInput"
            @change="onFileChange"
          />
        </div>

        <!-- Type -->
        <div class="col-md-6 mb-3">
          <label for="type" class="form-label">Type</label>
          <select
            class="form-select"
            id="type"
            v-model="customer.type"
            required
          >
            <option value="">Select Type</option>
            <option value="Company">Company</option>
            <option value="Person">Person</option>
          </select>
        </div>

        <!-- Address Line 1 -->
        <div class="col-md-6 mb-3">
          <label for="addressLine1" class="form-label">Address Line 1</label>
          <input
            type="text"
            class="form-control"
            id="addressLine1"
            v-model="customer.addressLine1"
            required
          />
        </div>

        <!-- City -->
        <div class="col-md-6 mb-3">
          <label for="city" class="form-label">City</label>
          <input
            type="text"
            class="form-control"
            id="city"
            v-model="customer.city"
            required
          />
        </div>

        <!-- State -->
        <div class="col-md-6 mb-3">
          <label for="state" class="form-label">State</label>
          <input
            type="text"
            class="form-control"
            id="state"
            v-model="customer.state"
          />
        </div>

        <!-- Country -->
        <div class="col-md-6 mb-3">
          <label for="country" class="form-label">Country</label>
          <input
            type="text"
            class="form-control"
            id="country"
            v-model="customer.country"
          />
        </div>

        <!-- Postal Code -->
        <div class="col-md-6 mb-3">
          <label for="postalCode" class="form-label">Postal Code</label>
          <input
            type="text"
            class="form-control"
            id="postalCode"
            v-model="customer.postalCode"
          />
        </div>

        <!-- Phone Number -->
        <div class="col-md-6 mb-3">
          <label for="phoneNumber" class="form-label">Phone Number</label>
          <input
            type="text"
            class="form-control"
            id="phoneNumber"
            v-model="customer.phoneNumber"
          />
        </div>

        <!-- Email -->
        <div class="col-md-6 mb-3">
          <label for="email" class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="customer.email"
            required
          />
        </div>
      </div>

      <!-- Submit Button and Spinner -->
      <button type="submit" class="btn btn-primary" :disabled="loading">
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Save Customer
      </button>
      <button
        type="button"
        class="btn btn-secondary ms-2"
        @click="$router.back()"
      >
        Cancel
      </button>
    </form>

    <!-- Result Message Placeholder -->
    <div v-if="message" class="mt-4">
      <div
        :class="{
          'alert alert-success': isSuccess,
          'alert alert-danger': !isSuccess,
        }"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getOauthToken } from "@/helper/utils1"; // Use `@` for the src directory
import { clearLocalStorageItem } from "@/localCache";
import { BC_API_BASE_URL } from "@/apiConfig";
import { logout } from "@/helper/utils1"; // Use `@` for the src directory


export default {
  data() {
    return {
      customer: {},
      message: null,
      isSuccess: false,
      loading: false, // Tracks the loading state
      custImageFile: null,
    };
  },
  methods: {
    // Store the selected file when it changes
    onFileChange(event) {
      this.custImageFile = event.target.files[0];
    },
    async addCustomer() {
      this.loading = true; // Start loading
      this.message = ""; // Clear any previous message
      // Process to save customer details
      try {
        const customersUrl = BC_API_BASE_URL + `/customers`;
        let response = await axios.post(customersUrl,
          this.customer, // This sends the customer JSON object in the request body
          {
            headers: {
              Authorization: `Bearer ` + getOauthToken(),
              "Content-Type": "application/json", // Set content type to JSON
            },
          }
        );

        let customer = response.data;
        console.log(customer);
        // Perform the PATCH request to update customer image
        if (this.custImageFile) {
          response = await axios.patch(
            BC_API_BASE_URL + `/customers(${customer.id})/picture/pictureContent`,
            this.custImageFile,
            {
              headers: {
                Authorization: `Bearer ` + getOauthToken(),
                "Content-Type": "application/octet-stream", // Specify binary content
                "If-Match": "*", // Additional header for conditional update
              },
            }
          );
        }

        this.message = "Customer added successfully!";
        this.isSuccess = true;
        clearLocalStorageItem(customersUrl); // flush the cache so that the customer list will fetched fresh
        console.log(response);
      } catch (error) {
        console.log(error);
        this.message = "Failed to add customer: " + error.message;
        this.isSuccess = false;
        if (error.status == 401) {
          logout(this.$router);
        }
      } finally {
        this.loading = false; // Stop loading after response
      }
      //this.$router.push('/customers')
    },
  },
};
</script>
